var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgraundPawprintBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31154_5314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.79 134.062C126.499 121.827 124.679 108.214 116.921 97.6488C109.163 87.0831 96.7194 81.2716 83.6369 82.1024L52.1113 84.1018C46.8811 84.4332 41.9996 86.3985 37.9974 89.7823C33.9943 93.1667 31.2467 97.6531 30.0484 102.758C28.8545 107.862 29.3249 113.103 31.4083 117.915C33.4916 122.726 36.9949 126.654 41.5368 129.274L41.8421 129.449C53.1854 136.105 61.3161 147.259 64.1763 160.106C64.9145 163.42 66.3064 166.483 68.273 169.161C69.3422 170.617 70.5831 171.96 71.9794 173.169C75.9452 176.598 80.8051 178.616 86.0346 179.005C91.2617 179.393 96.3666 178.115 100.796 175.309C105.225 172.503 108.561 168.434 110.445 163.542L121.79 134.062Z",
    fill: "#54ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.293 72.0416C80.8648 74.9765 86.4392 75.6632 91.9896 73.9745C97.2718 72.3683 101.923 68.7673 105.085 63.8331C108.245 58.9001 109.574 53.171 108.829 47.6999C108.045 41.9535 105.096 37.1743 100.526 34.2483C91.3402 28.3558 78.4275 32.0382 71.737 42.4616C66.4194 50.7683 66.6349 60.8768 71.5867 67.6206C72.8512 69.3425 74.4247 70.8449 76.293 72.0416Z",
    fill: "#54ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.665 86.3718C120.202 96.6358 135.847 98.0006 147.541 89.4137C159.238 80.8248 162.622 65.4869 155.085 55.2228C147.549 44.9598 131.902 43.5974 120.205 52.1863C108.511 60.7732 105.129 76.1087 112.665 86.3718Z",
    fill: "#54ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06 122.344L131.061 122.345C131.696 124.309 132.628 126.104 133.806 127.708C139.302 135.193 150.107 138.487 160.524 135.123C166.521 133.187 171.54 129.339 174.655 124.29C177.917 119.004 178.73 113.051 176.945 107.525C175.16 101.999 171.016 97.6466 165.278 95.2685C159.798 92.9967 153.477 92.8134 147.481 94.7514C134.833 98.8381 127.466 111.216 131.06 122.344Z",
    fill: "#54ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.319 159.727L162.32 159.722C162.351 148.805 152.312 139.883 139.936 139.834C127.561 139.794 117.459 148.639 117.416 159.549C117.399 163.529 118.723 167.245 121.012 170.362C125.001 175.795 131.924 179.411 139.798 179.445C152.172 179.484 162.275 170.64 162.319 159.727Z",
    fill: "#54ADFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31154_5314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.222,
    height: 157.222,
    fill: "white",
    transform: "translate(126.727) rotate(53.7104)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgraundPawprintBlue);
export default __webpack_public_path__ + "static/media/backgraund-pawprint-blue.eb8b03de2fd077469e55e1fe689618ea.svg";
export { ForwardRef as ReactComponent };